import { render, staticRenderFns } from "./EditChargerConnectors.vue?vue&type=template&id=980fc65e&lang=pug&"
import script from "./EditChargerConnectors.vue?vue&type=script&lang=ts&"
export * from "./EditChargerConnectors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports